// Style commun des champs de saisie du Compte (profil, PIN, methodes de
// connexion) — extrait en S54 pour ne pas dupliquer la chaine dans chaque vue.
export const classeChamp = (isWeb3) =>
  `w-full px-3.5 py-3 rounded-xl border text-[14px] outline-none transition ${
    isWeb3
      ? 'bg-[#0a0e13] border-[#252d38] text-white placeholder-white/30 focus:border-[rgb(var(--c-primary))]'
      : 'bg-[rgb(var(--c-creme))] border-[#ede4db] text-[rgb(var(--c-green))] placeholder-[rgb(var(--c-green))]/60 focus:border-[rgb(var(--c-primary))]'
  }`
